import React from 'react';
import { Col, Row, Tag, Typography } from 'antd';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

const statusColors: Record<string, string> = {
  queued: 'default',
  running: 'processing',
  completed: 'success',
  failed: 'error',
  cancelled: 'warning',
};

interface JobDetailProps {
  job: {
    id: string;
    job_name: string;
    tenant_id: string;
    tenant_name: string;
    queue_id: string;
    type: string;
    status: string;
    progress: number;
    started_at?: string;
    estimated_completion?: string;
    created_at: string;
    processed_items?: number;
    total_items?: number;
    error_message?: string;
  } | null;
}

export const JobDetail: React.FC<JobDetailProps> = ({ job }) => {
  if (!job) {
    return <div>No job selected</div>;
  }

  return (
    <div style={{ padding: 16 }}>
      <Title level={5}>Job Detail</Title>
      <Row gutter={[16, 8]}>
        <Col span={12}>
          <Text strong>Job ID:</Text>
          <br />
          <Text code>{job.id}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Job Name:</Text>
          <br />
          <Text>{job.job_name}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Tenant:</Text>
          <br />
          <Text>{job.tenant_name} ({job.tenant_id})</Text>
        </Col>
        <Col span={12}>
          <Text strong>Type:</Text>
          <br />
          <Text>{job.type}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Queue:</Text>
          <br />
          <Text code>{job.queue_id}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Status:</Text>
          <br />
          <Tag color={statusColors[job.status]}>{job.status.toUpperCase()}</Tag>
        </Col>
        <Col span={12}>
          <Text strong>Progress:</Text>
          <br />
          <Text>{job.progress}%</Text>
        </Col>
        <Col span={12}>
          <Text strong>Created At:</Text>
          <br />
          <Text>{dayjs(job.created_at).format('YYYY-MM-DD HH:mm:ss')}</Text>
        </Col>
        {job.started_at && (
          <Col span={12}>
            <Text strong>Started At:</Text>
            <br />
            <Text>{dayjs(job.started_at).format('YYYY-MM-DD HH:mm:ss')}</Text>
          </Col>
        )}
        {job.estimated_completion && (
          <Col span={12}>
            <Text strong>ETA:</Text>
            <br />
            <Text>{dayjs(job.estimated_completion).format('YYYY-MM-DD HH:mm:ss')}</Text>
          </Col>
        )}
        {job.processed_items !== undefined && (
          <Col span={12}>
            <Text strong>Processed Items:</Text>
            <br />
            <Text>{job.processed_items.toLocaleString()} / {job.total_items?.toLocaleString() || '-'}</Text>
          </Col>
        )}
        {job.error_message && (
          <Col span={24}>
            <Text strong style={{ color: 'red' }}>Error Message:</Text>
            <br />
            <Text style={{ color: 'red' }}>{job.error_message}</Text>
          </Col>
        )}
      </Row>
    </div>
  );
};